import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import FluidImageWrapper from '../FluidImageWrapper';
import ImageFluid from '../ImageFluid';
import Text from '../Text';
import Styles from './CardItem.styles';
import MoreImage from '../../../assets/images/Card/more.svg';

const Title = styled(Text)`
  ${Styles.title};
`;
const Container = styled.div`
  ${Styles.container};
`;
const InnerWrapper = styled.div`
  ${Styles.innerwrapper};
`;
const ImageWrapper = styled.div`
  ${Styles.imageWrapper};
`;

const Description = styled(Text)`
  ${Styles.description};
`;
const More = styled.a`
  ${Styles.more};
`;
const ClickContainer = styled.a``;

/**
 * CardItem component
 * @property {Object} props - component props
 * @returns {JSX}
 */
const CardItem = ({
  title, slug, className, image, gradientColor,  alt
}) => {
  const imgStyle = {};

  return (
    <Container
      className={className}
      gradientColor={gradientColor}
    >
      <ClickContainer href={slug}>
        <ImageWrapper>
          <ImageFluid fluid={image} imgStyle={imgStyle} alt={alt} />
        </ImageWrapper>
        <InnerWrapper>
          <Title className="cbx-bold" tag="h3">
            {title}
          </Title>
        </InnerWrapper>
      </ClickContainer>
    </Container>
  );
};

CardItem.propTypes = {
  gradientColor: PropTypes.oneOf(['pink', 'green', 'yellow']),
  title: PropTypes.string,
  className: PropTypes.string,
  alt: PropTypes.string
};

CardItem.defaultProps = {
  backgroundAlignment: 'center',
};

export default CardItem;
